import React, { FC } from 'react'

import { IconContactsProps } from './IconContacts.types'
import * as Styled from './styles/IconContacts.style'

import { nonThemeableRules } from '../../ruleSet'

const IconContacts: FC<IconContactsProps> = ({
  size = nonThemeableRules.defaultSize as number as IconContactsProps['size'],
  isResponsive = false,
}: IconContactsProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#cfc316fe-e300-4163-a7ec-36d098c7d31d__a)' strokeWidth='2'>
          <path
            d='M10.213 5.132h31.825v33.93a4 4 0 0 1-4 4H10.213a4 4 0 0 1-4-4V9.132a4 4 0 0 1 4-4Z'
            stroke='#0D0D0D'
            strokeMiterlimit='10'
          />
          <path
            d='M36.188 43.062V5.132m0 7.968h5.85m-5.85 10.998h5.85m-5.85 11.077h5.85'
            stroke='#0D0D0D'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M29.392 34.13c-.875-5.933-4.5-9.75-8.08-9.75s-7.305 3.825-8.182 9.75'
            stroke='#E60000'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M21.125 14.615h5.015v5.015a4.75 4.75 0 0 1-4.75 4.75h-.265a4.75 4.75 0 0 1-4.75-4.75v-.275a4.75 4.75 0 0 1 4.75-4.75v.01Z'
            stroke='#E60000'
            strokeMiterlimit='10'
          />
        </g>
        <defs>
          <clipPath id='cfc316fe-e300-4163-a7ec-36d098c7d31d__a'>
            <path d='M0 0h48v48H0z' fill='#fff' />
          </clipPath>
        </defs>
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconContacts
